<div class="multi-state-button-container">
    <button #btn *ngFor="let option of options; let i = index" class="btn btn-multi"
        (click)="onItemClick($event,option,i)" (blur)="onBlur()" [attr.aria-labelledby]="this.getOptionLabel(option)"
        [attr.aria-pressed]="isSelected(option)" [attr.title]="option.title" [attr.aria-label]="option.label"
        [attr.tabindex]="disabled ? null : tabindex" [ngClass]="{'highlight':isSelected(option), 
            'disabled': disabled || isOptionDisabled(option)}">{{getOptionLabel(option)}}
        <span style="display: block;">{{getAdditionalOptionLabel(option)}}</span>
    </button>
</div>